export default "__VITE_ASSET__19aede4a__"